module.exports = __webpack_public_path__ + "img/speech_12.68e598e3.jpeg";